<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="reviews">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <label></label>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ reviews.length - currentPage *
              itemsPerPage > 0 ? currentPage * itemsPerPage : reviews.length }} of {{ reviews.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="InstructorName"> {{ $t('Instructor') }}</vs-th>
        <vs-th sort-key="CourseClassName">{{ $t('CourseClass') }}</vs-th>
        <vs-th>{{ $t('Action') }}</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.Instructor.Name }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate" v-html="tr.CourseClass.Course.Name"></p>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <vx-tooltip :text="$t('StartExam')" position="left" delay=".3s">
                <router-link :to="{ name: 'InstructorFeedBackAnswer', params: { instructorAnswer: tr.ID } }"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"> <feather-icon icon="PlayIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current" /></router-link>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>
import moduleCourseReview from "@/store/customerReview/courseReview/moduleCourseReview.js";
export default {
  data() {
    return {
      itemsPerPage: 10,
      selected: [],
      isMounted: false
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    reviews() {
      return this.$store.state.CourseReviewList.CourseReviews;
    }
  },
  created() {
    if (!moduleCourseReview.isRegistered) {
      this.$store.registerModule("CourseReviewList", moduleCourseReview);
      moduleCourseReview.isRegistered = true;
    }
    this.$vs.loading();
    //var period = {};

    this.$store.dispatch("CourseReviewList/getAllInstructorFeedback").then(res => {
      this.$vs.loading.close(res);
    }).catch(err => {
      this.$vs.loading.close(err);
    });

    // let userInfo = JSON.parse(localStorage.getItem("userInfo"))
    // debugger
    // if (userInfo.userRole == "admin") {
    //   debugger
    //   this.$store.dispatch("CourseReviewList/getAllInstructorFeedback").then(res => {
    //     this.$vs.loading.close();
    //   }).catch(err => {
    //     this.$vs.loading.close();
    //   });
    // } else {
    //   this.$store.dispatch("CourseReviewList/getInstructorAvailableReviews", period).then(res => {
    //     this.$vs.loading.close();
    //   }).catch(err => {
    //     this.$vs.loading.close();
    //   });
    // }

  },
  mounted() {
    this.isMounted = true;
  }
}
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
